import styled from 'styled-components';
import { BoxGoogleAuth } from '../google-auth/styles';

const BoxTelegramAuth = styled(BoxGoogleAuth)`
  background: rgb(84 169 235);
`;

export { BoxTelegramAuth };
